export * from './calendar-config.view';